import { Dispatch, SetStateAction } from 'react';

export enum PlannerMode {
  BUILD = 'BUILD',
  PLAN = 'PLAN',
}

export enum PlannerBuildTool {
  DRAW = 'DRAW',
  INSIDE_DRAW = 'INSIDE_DRAW',
  ERASE = 'ERASE',
  SETTINGS = 'SETTINGS',
}

export interface PlannerContext {
  mode: PlannerMode;
  setModeDisabled: Dispatch<SetStateAction<boolean>>;
  modeDisabled: boolean;
  roomId: string;
  projectId: string;
}

export const PLANNER_HISTORY_MAX_LENGTH = 100;

export const DEFAULT_HEIGHT_M = 3;
export const DEFAULT_HEIGHT_FT = 10;
